import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {of} from "rxjs";
import {Product} from "../models/product.model";
import {environment} from "../../environments/environment";
import {
    isMarketplaceScreenMockEnabled,
    MARKETPLACE_SCREEN_MOCK_PRODUCTS
} from "../store/marketplace/marketplace.screen.mock";

@Injectable({
    providedIn: 'root',
})
export class MarketplaceService {
    #apiUrl = environment.apiUrl;
    #http = inject(HttpClient);
    #products = '/products';

    constructor() {}

    getProducts(searchType: 'purchasable' | 'all' = 'all') {
        if (isMarketplaceScreenMockEnabled()) {
            return of(MARKETPLACE_SCREEN_MOCK_PRODUCTS);
        }

        return this.#http.get<Product[]>(`${this.#apiUrl}${this.#products}?searchType=${searchType}`);
    }

    getProduct(productCode: string) {
        if (isMarketplaceScreenMockEnabled()) {
            const mockProduct = MARKETPLACE_SCREEN_MOCK_PRODUCTS.find(product => product.productCode === productCode);
            if (mockProduct) {
                return of(mockProduct);
            }
        }

        return this.#http.get<Product>(`${this.#apiUrl}${this.#products}/${productCode}`);
    }
}
